import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { Video } from 'src/app/models/video.model';
import { UsersService } from 'src/app/services/users.service';
import { VideosService } from 'src/app/services/videos.service';

@Component({
  selector: 'video-card',
  templateUrl: './video-card.component.html',
  styleUrls: ['./video-card.component.scss']
})
export class VideoCardComponent {

  constructor(private router: Router, private videoService: VideosService, private userService: UsersService) { }

  @ViewChild(MatTooltip) tooltip!: MatTooltip;
  protocol = window.location.protocol
  @Input()
  video: Video = {
    favorite: false,
    _id: "0",
    videoId: "",
    title: "",
    url: "",
    description: "",
    publishingDate: new Date(),
    channelId: "",
    channelTitle: "",
    tags: [],
    views: 0,
      relativeVideos: [],
    siteId:0,
    open: false,
    insertedAt: new Date(),
    score: 0, openForUsers: []
  }
  refreshing: boolean
  adding: boolean
  hover: boolean
  @Output()
  removedFromFavorites = new EventEmitter<string>()

  @Output()
  videoOpened: EventEmitter<any> = new EventEmitter<any>()

  timeoutIn: any
  timeoutOut: any

  url: string = this.router.url
  removeFromFavorite() {
    this.videoService.removeFavorite(this.video._id).subscribe(v => { console.log("remove favorite", v) })
    this.removedFromFavorites.emit(this.video._id)
  }

  openVideo() {
    this.video.open = true
  }

  hoverOn() {
    clearTimeout(this.timeoutOut)
    this.timeoutIn = setTimeout(() => this.hover = true, 600)
  }

  hoverOff() {
    clearTimeout(this.timeoutIn)
    this.timeoutOut = setTimeout(() => this.hover = false, 300)
  }

  addSite() {
    this.adding = true
    this.userService.sessionDetails.subscribe(data => {
      const windowsUsers = ''//data['WindowsUsers'] ? (Object.keys(data['WindowsUsers'])[0] + "-" + Object.values(data['WindowsUsers'])[0]) : ""
      const windowsMachine = ''// data['WindowsMachine'] ? data['WindowsMachine'] : ""
      const nativVersion = ''// data['NativVersion'] ? data['NativVersion'] : ""
      let userName, sites
      // this.userService.currentUser.subscribe(user => {
      // userName = user.login
      this.userService.currentUser.subscribe(user => {
        userName = user.login
        sites = [{ url: `https://www.youtube.com/watch?v=${this.video.videoId}`, comments: '' }]
        sites = JSON.stringify(sites)
        const reqData = JSON.stringify({
          cats: "", dec: -1, sid: -1, ref: "https://video.enativ.com/",
          windowsMachine, windowsUsers, nativVersion, reqIp: ""
        })
        this.userService.addSite(sites, reqData, userName)
          .subscribe(d => {
            this.adding = false
            if (user.activeList !== 2 && user.activeList !== 6)//אם הוא לא משתמש שרת יש לבצע רענון הגדרות
            {
              this.refreshing = true
              this.userService.refreshNativ().subscribe(d => {
                console.log(d)
                this.refreshing = false
                this.openVideo()
              }
                , e => {
                  console.log(e)
                  this.refreshing = false
                })
            }
            else
              this.openVideo()

            console.log(d)
          }, e => this.adding = false)
      })
    })
    // })
  }

}    